import styled from "@emotion/styled";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import isPes from "src/helpers/isPes";
import { Breakpoints, mq } from "src/helpers/mediaQuery";
import {
	getUserInfo,
	useGetSpecialisations,
	useSetSpecialisation,
} from "src/hooks/useUser";

import {
	hasAccessToLekExams,
	hasAccessToPesExams,
} from "../../../helpers/getPermissions";
import LEKSelect from "../../Default/LekUI/Select";
import DefaultModal from "./DefaultModal";

const Content = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  padding: 18px 12px;
  text-align: center;

  > h4 {
    font-size: 16px;
    margin: 38px 0 0;
  }

  > p {
    font-size: 14px;
    margin: 8px 0 24px;
  }

  > svg {
    position: absolute;
    top: -45px;
    left: -15px;
    transform: rotate(-25deg);
  }

  ${mq(Breakpoints.sm)} {
  }
`;

export default function SetSpecialisationModal() {
	const { t } = useTranslation();
	const { mutateAsync } = useSetSpecialisation();
	const [specialisationId, setSpecialisationId] = useState(null);
	const userInfo = getUserInfo();

	const isOpen =
		import.meta.env.SERVICE === "sistesty"
			? hasAccessToLekExams() && userInfo && !userInfo.selectedSpecialisation
			: isPes() &&
				hasAccessToPesExams() &&
				userInfo &&
				!userInfo.selectedSpecialisation;

	const { data: specializations, isLoading } = useGetSpecialisations(!!isOpen);

	const renderSpecialisation = () => {
		if (isLoading) {
			return null;
		}

		return (
			<LEKSelect
				title={t("modals.setSpecialisation.title")}
				value={specialisationId}
				onChange={(e) => setSpecialisationId(e.target.value)}
				options={specializations}
				optionKey="specialisation"
				disabledList={specializations.filter(
					(spec) =>
						!userInfo.availableSpecialisations.some((ps) => ps.id === spec.id),
				)}
			/>
		);
	};

	const setUserSpecialisation = async () => {
		await mutateAsync({
			id: specialisationId,
			specialization: specializations.find(
				(spec) => spec.id === specialisationId,
			),
		});
	};

	return (
		isOpen && (
			<DefaultModal
				primaryText={t("commands.save")}
				onPrimaryClick={setUserSpecialisation}
				fullWidth
			>
				<Content>
					<h4>{t("modals.setSpecialisation.header")}</h4>
					<p>{t("modals.setSpecialisation.subheader")}</p>
					{renderSpecialisation()}
				</Content>
			</DefaultModal>
		)
	);
}
